// Saha Masrafları (/saha-masraflari): masraf talepleri, analiz grafikleri ve
// visit harcamaları. Kategori / tip kayıtlı değerdir; CSV dosyası Türkçe kalır.
const fieldExpenses = {
  page: {
    title: 'Saha Masrafları',
    subtitle: 'Tüm saha masraf taleplerinin detaylı analizi ve yönetimi.',
  },
  actions: {
    advanced: 'Gelişmiş Filtre',
    advancedHint: 'Çalışan, tutar, tarih, gün, ay ve yıla göre süz',
    csv: 'CSV İndir',
    csvHint: 'Süzülmüş masraf taleplerini CSV olarak indir',
    approve: 'Onayla',
    reject: 'Reddet',
    delete: 'Sil',
  },
  tabs: {
    label: 'Bölüm',
    requests: 'Masraf Talepleri',
    requestsShort: 'Talepler',
    analysis: 'Analiz',
    visitsShort: 'Visit',
    visits: 'Visit Harcamaları',
  },
  stats: {
    total: 'Toplam Masraf',
    totalShort: 'Toplam',
    pending: 'Bekleyen Masraf',
    pendingShort: 'Bekleyen',
    approved: 'Onaylanan Masraf',
    approvedShort: 'Onaylanan',
    rejected: 'Reddedilen Masraf',
    rejectedShort: 'Reddedilen',
    average: 'Ortalama Masraf',
    averageShort: 'Ortalama',
    people: 'Talep Eden Kişi',
    peopleShort: 'Kişi',
    requests: '{{count}} talep',
    rate: '%{{rate}} oran',
  },
  status: {
    pending: 'Bekliyor',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
  },
  categories: {
    transport: 'Ulaşım',
    meal: 'Yemek',
    accommodation: 'Konaklama',
    supplies: 'Malzeme',
    training: 'Eğitim',
    other: 'Diğer',
  },
  toolbar: {
    search: 'Çalışan, açıklama veya kategori ara…',
    searchShort: 'Masraf ara…',
    status: 'Durum',
    allStatuses: 'Tümü',
    category: 'Kategori',
    allCategories: 'Tümü',
    period: 'Dönem',
    ranges: {
      all: 'Tüm Zamanlar',
      '7d': 'Son 7 Gün',
      '30d': 'Son 30 Gün',
      '90d': 'Son 90 Gün',
      '1y': 'Son 1 Yıl',
    },
    sort: 'Sırala',
    sortBy: {
      createdAt: 'Tarih',
      amount: 'Tutar',
      employeeName: 'Çalışan',
    },
    asc: 'Artan sıra',
    desc: 'Azalan sıra',
  },
  columns: {
    employeeName: 'Çalışan',
    actions: 'İşlem',
    amount: 'Tutar',
    category: 'Kategori',
    status: 'Durum',
    createdAt: 'Tarih',
    description: 'Açıklama',
    receipt: 'Dekont',
  },
  table: {
    listLabel: 'Masraf talepleri',
    empty: 'Eşleşen masraf talebi bulunamadı',
    unknown: 'Bilinmeyen',
    rangeOf: '/ {{total}} talep',
    ofTotal: 'toplam {{total}} talep içinden',
    jump: 'Sayfaya git',
  },
  receipt: {
    view: 'Dekontu Görüntüle',
    download: 'Dekontu İndir',
  },
  panel: {
    label: 'Seçili masraf talebi',
    heading: 'Masraf talebi',
    rejectionReason: 'Reddedilme nedeni',
    rejectedBy: 'Reddeden',
    updatedAt: 'Son güncelleme',
  },
  reject: {
    title: 'Masraf Talebini Reddet',
    description: 'Lütfen masraf talebini neden reddettiğinizi açıklayın. Bu bilgi çalışana iletilecektir.',
    reason: 'Reddedilme Nedeni',
    placeholder: 'Örn: Dekont eksik, tutar hatalı, onaysız harcama…',
    submit: 'Reddet',
    rejecting: 'Reddediliyor…',
  },
  delete: {
    title: 'Talep silinsin mi?',
    message: '{{name}} adlı çalışanın masraf talebi kalıcı olarak silinecek.',
  },
  advanced: {
    title: 'Gelişmiş Filtreleme',
    subtitle: 'Seçimler masraf tablosuna, göstergelere ve grafiklere uygulanır',
    all: 'Tümü',
    status: 'Durum',
    category: 'Kategori',
    employee: 'Çalışan',
    dateFrom: 'Başlangıç Tarihi',
    dateTo: 'Bitiş Tarihi',
    amountMin: 'Min Tutar (₺)',
    amountMax: 'Max Tutar (₺)',
    weekday: 'Haftanın Günü',
    month: 'Ay',
    year: 'Yıl',
    reset: 'Sıfırla',
    apply: 'Uygula',
  },
  charts: {
    all: 'Grafikler tüm masraf taleplerinden ({{count}}) hesaplanır.',
    filtered: 'Grafikler süzülmüş {{count}} talepten hesaplanır.',
    clear: 'Filtreleri temizle',
    empty: 'Gösterilecek veri yok',
    monthly: 'Aylık Masraf Trendi',
    category: 'Kategori Dağılımı',
    status: 'Durum Dağılımı',
    topSpenders: 'En Yüksek Masraf Talep Edenler',
    weekly: 'Haftalık Dağılım',
    categoryAmount: 'Kategoriye Göre Toplam Tutar',
    approved: 'Onaylanan',
    pending: 'Bekleyen',
    rejected: 'Reddedilen',
    total: 'Toplam',
    count: 'Talep Sayısı',
    amount: 'Toplam Tutar',
  },
  visits: {
    listLabel: 'Visit harcamaları',
    search: 'Çalışan, masraf adı, merkez ara…',
    searchShort: 'Harcama ara…',
    type: 'Tip',
    allTypes: 'Tüm Tipler',
    empty: 'Visit harcaması bulunamadı',
    rangeOf: '/ {{total}} kayıt',
    ofTotal: 'toplam {{total}} kayıt içinden',
    panelLabel: 'Seçili visit harcaması',
    panelHeading: 'Visit harcaması (bilgi)',
    untitled: 'Adsız harcama',
    center: 'Merkez',
    attachment: 'Dosya {{index}}',
    stats: {
      total: 'Toplam Visit Harcaması',
      totalShort: 'Toplam',
      records: '{{count}} kayıt',
      visits: 'Ziyaret Sayısı',
      visitsShort: 'Ziyaret',
      employees: 'Çalışan Sayısı',
      employeesShort: 'Çalışan',
    },
    columns: {
      employeeName: 'Çalışan',
      name: 'Masraf Adı',
      type: 'Tip',
      cost: 'Maliyet',
      visitDate: 'Visit Tarihi',
      information: 'Bilgi',
      attachments: 'Dosyalar',
      createdAt: 'Eklenme',
    },
  },
  visitTypes: {
    transportation: 'Ulaşım',
    accommodation: 'Konaklama',
    meal: 'Yemek',
    supplies: 'Malzeme',
    other: 'Diğer',
  },
  common: {
    cancel: 'İptal',
  },
  toast: {
    loadError: 'Veriler yüklenirken hata oluştu.',
    visitsError: 'Visit harcamaları yüklenirken hata oluştu.',
    approved: 'Talep onaylandı!',
    rejected: 'Talep reddedildi.',
    reasonRequired: 'Lütfen reddedilme nedenini giriniz.',
    actionError: 'İşlem sırasında hata oluştu.',
    deleted: 'Talep silindi.',
    deleteError: 'Silme işlemi başarısız.',
    noPdf: 'PDF dosyası bulunamadı',
    filtersApplied: 'Filtreler uygulandı',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default fieldExpenses;
